export default {
  username: 'Username',
  email: 'Email',
  mobile: 'Mobile'
}